import React, { ImgHTMLAttributes } from 'react';

import { PNG_IMAGES, PngImageName } from './images';

type Props = {
    name: PngImageName;
} & ImgHTMLAttributes<HTMLImageElement>;

export function PngImage({ name, ...props }: Props) {
    return <img src={PNG_IMAGES[name]} {...props} />;
}
